import React, { useState } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import Swal from 'sweetalert2';
import baseURL from '../url';
import './FeedbackModal.css';

export default function FeedbackModal({ isOpen, onClose, pedidoId, nombreCliente, telefonoCliente }) {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [comentario, setComentario] = useState('');
    const [enviando, setEnviando] = useState(false);

    const handleSubmit = async () => {
        if (rating === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Rating requerido',
                text: 'Por favor selecciona una calificación',
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }

        setEnviando(true);

        try {
            const response = await fetch(`${baseURL}/evaluacionSave.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    idPedido: pedidoId,
                    rating: rating,
                    comentario: comentario.trim() || null,
                    nombreCliente: nombreCliente || null,
                    telefonoCliente: telefonoCliente || null
                })
            });

            const data = await response.json();

            if (data.success) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Gracias por tu valoración!',
                    text: 'Tu opinión es muy importante para nosotros',
                    timer: 2500,
                    showConfirmButton: false
                });
                onClose();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'No se pudo guardar la evaluación',
                    confirmButtonColor: '#da4a1c'
                });
            }
        } catch (error) {
            console.error('Error al enviar evaluación:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error de conexión. Por favor, inténtelo de nuevo.',
                confirmButtonColor: '#da4a1c'
            });
        } finally {
            setEnviando(false);
        }
    };

    const handleClose = () => {
        if (!enviando) {
            onClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            className="modal-feedback"
            overlayClassName="overlay-feedback"
            onRequestClose={handleClose}
            ariaHideApp={false}
        >
            <div className="feedback-content">
                <h2>Califica tu pedido</h2>
                <p className="feedback-subtitle">Tu opinión nos ayuda a mejorar</p>

                <div className="stars-container">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            type="button"
                            className="star-button"
                            onClick={() => setRating(star)}
                            onMouseEnter={() => setHoverRating(star)}
                            onMouseLeave={() => setHoverRating(0)}
                            aria-label={`${star} estrella${star > 1 ? 's' : ''}`}
                        >
                            <FontAwesomeIcon
                                icon={star <= (hoverRating || rating) ? faStar : faStarRegular}
                                className={star <= (hoverRating || rating) ? 'star-filled' : 'star-empty'}
                            />
                        </button>
                    ))}
                </div>

                <div className="rating-text">
                    {rating === 0 && <span>Selecciona tu calificación</span>}
                    {rating === 1 && <span>😞 Muy malo</span>}
                    {rating === 2 && <span>😕 Malo</span>}
                    {rating === 3 && <span>😐 Regular</span>}
                    {rating === 4 && <span>😊 Bueno</span>}
                    {rating === 5 && <span>😍 Excelente</span>}
                </div>

                <div className="feedback-textarea-container">
                    <label htmlFor="comentario">Comentario (opcional)</label>
                    <textarea
                        id="comentario"
                        value={comentario}
                        onChange={(e) => setComentario(e.target.value)}
                        placeholder="Cuéntanos sobre tu experiencia..."
                        maxLength={1000}
                        rows={4}
                    />
                    <span className="char-count">{comentario.length}/1000</span>
                </div>

                <div className="feedback-buttons">
                    <button
                        className="btn-secondary-feedback"
                        onClick={handleClose}
                        disabled={enviando}
                    >
                        Cerrar
                    </button>
                    <button
                        className="btn-primary-feedback"
                        onClick={handleSubmit}
                        disabled={enviando || rating === 0}
                    >
                        {enviando ? 'Enviando...' : 'Enviar'}
                    </button>
                </div>
            </div>
        </Modal>
    );
}





